// extracted by mini-css-extract-plugin
export default {"container":"InfoListBannerItem__container___INGYy","text":"InfoListBannerItem__text___YD4Aw","title":"InfoListBannerItem__title___vsN4k","image":"InfoListBannerItem__image___K1rYi"};